export default{
  data() {
      return {
          apis: {
              byInst:'sh/wf/track/byInst',//根据实例主键获取流程轨迹
              byBiz:'sh/wf/track/byBiz',//根据业务主键流程轨迹
          },
          constant:{
            TASK_TYPE_APPROVE: 1,//任务类型，审批任务
            TASK_TYPE_DUPLICATE: 2,//任务类型，抄送任务
            WF_TRACK_STATUS_APPLY: 1,/***任务状态：待审批*/
            WF_TRACK_STATUS_PASS: 2,/***任务状态：通过*/
            WF_TRACK_STATUS_REJECT: 3,/***任务状态：驳回*/
            WF_TRACK_STATUS_TURN: 4,/***任务状态：已转审*/
            WF_TRACK_STATUS_ABORTED: 5,/***任务状态：已撤销*/
            WF_TRACK_STATUS_CATCH_BACK: 6,/***任务状态：被抓回*/
            WF_TRACK_STATUS_RESTART: 7,/***任务状态：反办结*/
          },//
          tracks:[],//流程轨迹列表
          verdicts:['待审核', '通过', '驳回'],//处理结论
      }
  },
  watch: {
      bizKey(){
          this.loadTracks();
      },
      instKey(){
          this.loadTracks();
      }
  },
  props:{
      instKey:null,//实例主键
      bizKey:null,//业务主键
  },
  mounted() {
    this.loadTracks();
  },
  methods: {
      loadTracks(){
          const me = this;
          me.instKey ? me.byInst() : me.byBiz();
      },
      byInst(){//获取流程轨迹
          const me = this;
          me.tracks = [];
          if(!me.instKey){
              return;
          }
          me.$post({
            url:me.apis.byInst,
            params:me.instKey
          }).then(rsp=>{
            if(rsp.success){
              me.tracks = rsp.retList;
            }
          });
      },
      byBiz(){
          const me = this;
          me.tracks = [];
          if(!me.bizKey){
              return;
          }
          me.$post({
            url:me.apis.byBiz,
            params:me.bizKey
          }).then(rsp=>{
            if(rsp.success){
              me.tracks = rsp.retList;
            }
          });
      }
  },
}


// WEBPACK FOOTER //
// ./src/components/base/view/wf/exec/cmps/track/list/src/list.js